import { VideoEnhancerApp } from '@/components/enhancer/VideoEnhancerApp';

const VideoEnhancerPage = () => {
  return <VideoEnhancerApp />;
};

export default VideoEnhancerPage;
